
  //@CF fill in 


export default function Faq3() {
  return (
    <div>
          <h2 className="faq-header">Why are you using AI? </h2>

          <div className="faq-content">
          <p>
            To accurately predict the shaded locations for specific time of the day and year.
          </p>
          </div>

         
    </div>
  );
}
